import styled from 'styled-components';
import '../../styles/GlobalThemeStyle';
import {
	Button,
	Card,
	Table,
	Checkbox,
	Collapse,
	Tabs,
	Radio,
	Input,
	Dropdown,
	Tag,
	Steps,
	Select,
	DatePicker,
	Upload,
	Progress,
	Carousel,
} from 'antd';
import Lottie from 'lottie-react';

const { TextArea } = Input;
export const ParaShieldLeftScrollWrapper2 = styled.div`
	width: 100%;
	position: relative;
	min-height: calc(100vh - 110px);
	display: block;
	background: transparent;
	.header {
		position: absolute;
		z-index: 6;
		top: 1px;
		left: 15px;
		right: 15px;
		background: ${({ theme }) => theme.CQColors.white};
		border-bottom: 1px solid ${({ theme }) => theme.CQColors.themeColor4};
		border-radius: 16px 16px 0px 0px;
		padding: 10px 10px 10px 10px;
		em {
			width: 30px;
			height: 30px;
			border-radius: 50%;
			display: block;
			background: ${({ theme }) => theme.CQColors.gradientBg};
		}
		&.leftHeaderData {
			width: calc(100% - 30px);
			display: block;
			background: ${({ theme }) => theme.CQColors.white} !important;
			font-weight: 500;
			font-size: 14px;
			line-height: 60px;
			color: ${({ theme }) => theme.CQColors.themeColor2};
			padding: 10px 15px 0px 15px;
			border-bottom: 1px solid #f0f0f0;
			border-radius: 16px 16px 0px 0px;
			left: 15px;
			right: 15px;
			.leftTitleAnimation {
				width: 60px;
				height: 60px;
				float: left;
			}
		}
	}
	.footer {
		position: absolute;
		z-index: 1;
		left: 10px;
		right: 10px;
		background: ${({ theme }) => theme.CQColors.white};
		border-radius: 16px;
		bottom: 0px;
		padding: 10px;
	}
	.leftScrollData {
		width: 100%;
		position: relative;
		height: calc(100vh - 110px);
		min-height: 100%;
		overflow-y: auto;
		padding: 60px 20px 160px 20px !important;
		background: ${({ theme }) => theme.CQColors.white};
		border: 1px solid #f0f0f0;
		border-radius: 16px;
		&::-webkit-scrollbar {
			display: none;
		}
		
		scrollbar-width: none;
		&.RightScrollData {
			padding: 80px 20px !important;
			overflow-y: auto;
			.rightScrollDataTitle {
				font-weight: 500;
				font-size: 16px;
				line-height: 24px;
				color: ${({ theme }) => theme.CQColors.themeColor2};
				span {
					font-weight: 400;
					color: ${({ theme }) => theme.CQColors.themeColor3};
				}
			}
		}
		&.noPaddingbottom {
			padding-bottom: 15px !important;
		}
		.asistCardTitle {
			background: linear-gradient(180deg, #212226 0%, #007299 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			background-clip: text;
			text-fill-color: transparent;
			font-weight: 400;
			font-size: 20px;
			line-height: 28px;
		}
		.cardSuggestions {
			display: flex;
			flex-direction: column;
			min-height: 100%;
			overflow-y: auto;
			height: 100%;
			h3 {
				margin: 0px;
				font-weight: 500;
				font-size: 16px;
				line-height: 20px;
				text-align: center;
				color: ${({ theme }) => theme.colors.themeColor1};
			}
			p {
				margin: 0px;
				font-weight: 400;
				font-size: 12px;
				line-height: 20px;
				text-align: center;
				color: ${({ theme }) => theme.colors.themeColor33};
				margin-bottom: 3px;
			}
		}
		/* div .ant-form-item-control-input {
			min-height: 0px !important;
		} */
		/********* Chat interface *********/

		.textChat {
			width: 98%;
			position: relative;
			.textChatContainer {
				display: block;
				background: ${({ theme }) => theme.colors.white};
				border-radius: 10px;
				margin-bottom: 5px;
				padding: 10px 0px;
				height: 100%;
				overflow: auto;

				.cardHeader {
					margin: 5px 0px;
					background: #f3f9f9;
					border: 1px solid
						${({ theme }) => theme.CQColors.borderColor};
					border-radius: 10px;
					padding: 10px 15px;
					font-weight: 400;
					font-size: 12px;
					line-height: 18px;
					color: ${({ theme }) => theme.CQColors.themeColor2};
					span {
						margin-right: 5px;
						padding: 5px 10px;
						background: ${({ theme }) => theme.CQColors.white};
						border: 1px solid
							${({ theme }) => theme.CQColors.borderColor};
						border-radius: 10px;
						font-weight: 500;
						font-size: 12px;
						line-height: 18px;
						color: ${({ theme }) => theme.CQColors.themeColor2};
					}
				}
				.cardHeaderWithContent {
					width: 100%;
					margin: 5px 0px;
					.headerContent {
						background: #f3f9f9;
						border: 1px solid
							${({ theme }) => theme.CQColors.borderColor};
						border-bottom: none;
						border-radius: 10px 10px 0px 0px;
						padding: 10px 15px;
						font-weight: 400;
						font-size: 12px;
						line-height: 18px;
						color: ${({ theme }) => theme.CQColors.themeColor2};
						span {
							margin-right: 5px;
							padding: 5px 10px;
							background: ${({ theme }) => theme.CQColors.white};
							border: 1px solid
								${({ theme }) => theme.CQColors.borderColor};
							border-radius: 10px;
							font-weight: 500;
							font-size: 12px;
							line-height: 18px;
							color: ${({ theme }) => theme.CQColors.themeColor2};
						}
					}
					.cardHeaderContent {
						width: 100%;
						background: ${({ theme }) => theme.CQColors.white};
						padding: 10px 15px;
						border: 1px solid
							${({ theme }) => theme.CQColors.borderColor};
						border-top: none;
						border-radius: 0px 0px 10px 10px;
						hr {
							margin: 10px 0px;
							border: 1px solid
								${({ theme }) => theme.CQColors.borderColor};
						}
						span {
							font-weight: 400;
							font-size: 12px;
							line-height: 18px;
							color: ${({ theme }) => theme.CQColors.themeColor2};
						}
						a {
							font-weight: 400;
							font-size: 12px;
							line-height: 18px;
							color: ${({ theme }) => theme.CQColors.themeColor1};
						}
					}
				}

				.textChatImage {
					width: 25px;
					float: left;
					min-height: 100%;
					img {
						max-width: 30px;
						max-height: 30px;
					}
				}
				.textChatText {
					margin-top: 2px;
					float: right;
					width: calc(100% - 40px);
					word-wrap: break-word;
					font-weight: 400;
					font-size: 13px;
					line-height: 20px;
					color: ${({ theme }) => theme.colors.themeColor1};
					white-space: pre-wrap; /* Add this line to preserve spacing */
					text-align: left; /* Add this line to ensure left alignment */
					ol,
					ul {
						padding-left: 20px !important;
					}
					ul.systemList {
						margin: 0px;
						padding: 0px;

						li {
							list-style-type: decimal;
							margin-left: 20px;
							margin-bottom: 3px;
							ul {
								margin: 5px 0px 0px 20px;
								padding: 0px;
								li {
									list-style-type: disc;
									margin-left: 0px;
									ul {
										margin: 0px;
										padding: 0px;
										li {
											list-style-type: disc;
											margin-left: 15px;
										}
									}
								}
							}
						}
					}
					ul.systemListIcon {
						margin: 7px 0;
						padding-left: 0px !important;
						li {
							display: list-item;
							list-style-type: none;
							margin-bottom: 4px;
							padding-left: 25px;
							&.icon1 {
								background: url('/images/chat-system-icon-1.svg')
									no-repeat left center;
							}
							&.icon2 {
								background: url('/images/chat-system-icon-2.svg')
									no-repeat left center;
							}
							&.icon3 {
								background: url('/images/chat-system-icon-3.svg')
									no-repeat left center;
							}
						}
					}
					ul.systemListCheckbox {
						margin: 7px 0;
						padding-left: 0px !important;
						li {
							display: list-item;
							list-style-type: none;
							margin-bottom: 4px;
							padding-left: 0px;
						}
					}
				}
			}
		}
		.textChat.textChat_reply {
			.textChatContainer {
				background: transparent;
				display: block;
				margin-bottom: 5px;
				padding: 10px 0px;
				height: 100%;
				overflow: auto;
				.textChatImage {
					width: 25px;
					float: left;
					min-height: 100%;
					img {
						max-width: 30px;
						max-height: 30px;
					}
				}
				.textChatText {
					float: right;
					width: calc(100% - 40px);
					word-wrap: break-word;
					font-weight: 400;
					font-size: 13px;
					line-height: 20px;
					color: ${({ theme }) => theme.colors.themeColor1};
				}
			}
		}
	}
	.ant-form-item-control-input {
		min-height: 0px !important;
	}
`;
export const XTextAreaShieldMaxx2 = styled(TextArea)`
	background: ${({ theme }) => theme.CQColors.themeColor7};
	color: ${({ theme }) => theme.CQColors.themeColor3};
	border: 1px solid rgba(0, 0, 0, 0.05) !important;
	backdrop-filter: blur(21px);
	padding-bottom: 50px !important;
	resize: none !important;
	&:hover,
	&:focus,
	&:active,
	&:focus-visible {
		border-color: ${({ theme }) => theme.CQColors.themeColor1}!important;
		box-shadow: none !important;
	}
	&.smallChatBox {
		padding-bottom: 45px !important;
		background: ${({ theme }) => theme.CQColors.bodyBg} !important;
	}
	&:disabled {
		background: #f9f9f9 !important;
	}
`;
export const XTextAreaShieldMaxxBTN2 = styled.div`
	position: absolute;
	width: calc(100% - 40px);
	background: ${({ theme }) => theme.CQColors.bodyBg}!important;
	padding: 5px 0px;
	bottom: 0.5px;
	left: 20px;
	right: 20px;
	font-weight: 400;
	font-size: 12px;
	line-height: 18px;
	color: ${({ theme }) => theme.CQColors.themeColor3};
	&.smallChatBox {
		background: ${({ theme }) => theme.CQColors.bodyBg} !important;
		bottom: 7px !important;
		padding: 2px;
	}
	.iconButtonLeft {
		float: left;
		margin-top: 2px;
		cursor: pointer;
	}
	.iconButtonRight {
		float: right;
		cursor: pointer;
	}
	&.mainUpload {
		.ant-upload-list {
			position: absolute;
			top: -270%;
			left: 0px;
			right: 0px;
			max-width: 200px;
			background: ${({ theme }) => theme.CQColors.bodyBg};
			border-radius: 16px;
			margin-top: 7px;
			.ant-upload-list-item-container,
			.ant-upload-list-item {
				margin: 0px !important;
			}
			.ant-upload-list-item {
				background: ${({ theme }) => theme.CQColors.white};
			}
		}
	}
	&.innerUpload {
		.ant-upload-list {
			position: absolute;
			top: -170%;
			left: -10px;
			right: -10px;
			width: calc(100% + 20px);
			background: ${({ theme }) => theme.CQColors.bodyBg};
			border-radius: 16px;
			margin-top: 2px;
			.ant-upload-list-item-container,
			.ant-upload-list-item {
				margin: 0px !important;
			}
			.ant-upload-list-item {
				background: ${({ theme }) => theme.CQColors.white} !important;
				padding: 10px;
				height: auto;
			}
		}
	}
`;
export const XAgentMaxTitle = styled.div`
	margin: 0px;
	width: 100%;
	position: relative;
	span {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: block;
		max-width: 150px;
		font-weight: 500;
		font-size: 14px;
		line-height: 24px;
		color: ${({ theme }) => theme.CQColors.themeColor2};
	}
`;
export const XThemeVoiceBatchDetails = styled(Card)`
	position: relative;
	background: ${({ theme }) => theme.CQColors.white};
	border-radius: 10px;
	border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
	height: 100% !important;
	.ant-card-body {
	}
	.cardTitle {
		font-weight: 500;
		font-size: 14px;
		line-height: 28px;
		color: ${({ theme }) => theme.CQColors.themeColor2};
		svg {
			color: ${({ theme }) => theme.CQColors.themeColor1};
			font-size: 16px;
			margin-left: 5px;
		}
		span {
			font-weight: 700;
			font-size: 14px;
			line-height: 22px;
			text-transform: uppercase;
			background: transparent;
			color: ${({ theme }) => theme.CQColors.themeColor1};
		}
	}
	.cardNumbers {
		font-weight: 600;
		font-size: 24px;
		line-height: 36px;
		color: ${({ theme }) => theme.CQColors.themeColor2};
	}
	.cardText {
		font-weight: 400;
		font-size: 12px;
		line-height: 18px;
		color: ${({ theme }) => theme.CQColors.themeColor3};
	}
`;
export const CustomSevenStepProgress = styled.div`
	position: relative;
	width: 100%;
	height: 80px;
	margin: 0 auto;
	display: flex;
	justify-content: center;
	align-items: center;

	.progress-center {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 110px;
		height: 110px;
		border-radius: 50%;
		background-color: white;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		font-weight: 400;
		color: ${({ theme }) => theme.CQColors.themeColor3};
		z-index: 2;
	}
`;
export const CustomCarousel = styled(Carousel)`
	margin-top: 10px;
	button {
		z-index: 9999;
		opacity: 1;
		&::after {
			color: ${({ theme }) => theme.CQColors.themeColor2} !important;
		}
		&.slick-prev {
			left: 0px !important;
			opacity: 1;
		}
		&.slick-next {
			right: 0px !important;
			opacity: 1;
			z-index: 2;
		}
	}
	&::after {
		content: '';
		position: absolute;
		width: 50px;
		height: 100%;
		right: 0px;
		top: 50%;
		transform: translateY(-50%);
		background: linear-gradient(
			90deg,
			rgba(255, 255, 255, 0) 0%,
			#ffffff 58.87%
		);
		z-index: 1;
	}
	.cardItem {
		cursor: pointer;
		background: ${({ theme }) => theme.CQColors.white};
		color: ${({ theme }) => theme.CQColors.themeColor1};
		border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
		border-radius: 10px;
		margin-right: 10px;
		padding: 10px;
		display: flex;
		align-items: center;
		h1 {
			margin: 0px;
			font-weight: 500;
			font-size: 14px;
			line-height: 16px;
			color: ${({ theme }) => theme.CQColors.themeColor2};
		}
		h4 {
			margin: 0px;
			font-weight: 400;
			font-size: 12px;
			line-height: 16px;
			color: ${({ theme }) => theme.CQColors.themeColor3};
		}
	}
`;
export const CustomProgress2Wrapper = styled.div`
	border: 1px solid rgba(97, 175, 74, 0.2);
	border-radius: 50%;
	display: inline-block;
	padding: 13px;
`;
export const CustomProgress2 = styled(Progress)`
	.ant-progress-inner {
		position: relative;
		& > svg {
			transform: rotate(180deg);
		}
		&::after {
			content: '';
			position: absolute;
			top: ${(props) => props.$strokewidth}px;
			left: ${(props) => props.$strokewidth}px;
			width: calc(100% - ${(props) => props.$strokewidth * 2}px);
			height: calc(100% - ${(props) => props.$strokewidth * 2}px);
			border-radius: 50%;
			background: #fff;
			box-shadow: inset 0px 4px 13px rgba(0, 0, 0, 0.3);
			/* border: 0.5px solid #61af4a; */
		}
	}
	.ant-progress-text {
		position: relative;
		z-index: 1;
		font-weight: 500;
		font-size: 16px !important;
		line-height: 36px !important;
		color: #208181 !important;
	}
`;
export const XTheme2MiddleCard = styled(Card)`
	.cardBorder {
		width: 100%;
		position: relative;
		display: flex;
		align-items: center;
		border-right: 1px solid rgba(97, 175, 74, 0.2);
		@media only screen and (max-width: 1199.99px) {
			border-right: none;
		}
		h4 {
			margin: 0px;
			font-weight: 400;
			font-size: 12px;
			line-height: 16px;
			color: ${({ theme }) => theme.CQColors.themeColor2};
		}
		h1 {
			margin: 0px;
			font-weight: 500;
			font-size: 16px;
			line-height: 24px;
			color: ${({ theme }) => theme.CQColors.themeColor2};
		}
	}
`;
export const XTheme2FilledCard = styled.div`
	width: 100%;
	position: relative;
	display: grid;
	grid-template-columns: repeat(6, auto);
	gap: 5px;
	@media only screen and (max-width: 1440.99px) {
		grid-template-columns: repeat(3, auto);
	}
	@media only screen and (max-width: 991.99px) {
		grid-template-columns: repeat(3, auto);
	}
	@media only screen and (max-width: 575.99px) {
		grid-template-columns: repeat(2, auto);
	}
	.cardItem {
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: start;
		border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
		border-radius: 10px;
		padding: 10px 5px; /* optional: spacing inside cards */
		h4 {
			margin: 0px;
			font-weight: 400;
			font-size: 12px;
			line-height: 16px;
			color: ${({ theme }) => theme.CQColors.themeColor3};
		}
		h1 {
			margin: 0px;
			font-weight: 500;
			font-size: 14px;
			line-height: 16px;
			color: ${({ theme }) => theme.CQColors.themeColor2};
		}
		&.active {
			background: rgba(22, 145, 145, 0.05);
			border: 1px solid rgba(22, 145, 145, 0.15);
		}
	}
`;

/***********************End new chat*********************** */
export const XThemeFitToScreen = styled(Card)`
	width: 95%;
	position: fixed;
	font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
	height: 100vh;
	left: 188px;
	top: 65px;
	/* background: linear-gradient(
		180deg,
		rgba(255, 255, 255, 0.5) 0%,
		rgba(216, 239, 244, 0.5) 100%
	); */
	border: none !important;
	border-radius: 0px;
	padding-right: 80px;
	.ant-card-body {
		padding: 15px;
	}
	@media only screen and (max-width: 992px) {
		position: relative;
		padding-right: 0px !important;
		left: auto;
		top: auto;
		height: 100%;
	}
	&:after {
		position: absolute;
		content: '';
		top: 0;
		left: 0;
		width: 100%;
		height: 25%;
		background: repeating-linear-gradient(
			to right,
			#ececec,
			transparent 1px,
			transparent 100px
		);
		opacity: 1;
		pointer-events: none;
		z-index: -1;
	}
`;
// export const XThemeVoiceAssCard = styled(Card)`
// 	width: 100%;
// 	position: relative;
// 	border: none;
// 	border-radius: 0px;
// 	background: transparent !important;
// 	max-height: calc(100vh - 110px);
// 	@media only screen and (max-width: 992px) {
// 		height: 100%;
// 		max-height: 100%;
// 		overflow: auto;
// 	}
// 	&:hover {
// 		overflow-y: scroll;
// 	}
// 	&::-webkit-scrollbar {
// 		width: 1px;
// 		height: 1px;
// 		border: transparent;
// 	}
// 	&::-webkit-scrollbar-track {
// 		border-radius: 0px;
// 		background: ${({ theme }) => theme.colors.themeColor22};
// 	}
// 	&::-webkit-scrollbar-thumb {
// 		border-radius: 10px;
// 		background: ${({ theme }) => theme.colors.themeColor8};
// 	}
// `;

export const XThemeVoiceAssTitle = styled.h1`
	margin: 0px;
	font-weight: 400;
	font-size: 20px;
	line-height: 36px;
	color: #212226;
	span {
		color: ${({ theme }) => theme.colors.themeColor33};
	}
`;
export const XThemeTilesCard = styled(Card)`
	width: 100%;
	position: relative;
	background: ${({ theme }) => theme.colors.white};
	.ant-card-body {
		padding: 15px;
	}
	&.pending {
		background: #fffaf0;
	}
	&.analysed {
		background: #f3f1ff;
	}
	&.allocated {
		background: #eaf2ff;
	}
	&.rejected {
		background: #ffebe7;
	}
	.title {
		font-weight: 400;
		font-size: 14px;
		line-height: 20px;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
	.numberTitle {
		font-weight: 500;
		font-size: 24px;
		line-height: 20px;
		sub {
			font-weight: 400;
			font-size: 14px;
			line-height: 20px;
			color: ${({ theme }) => theme.colors.themeColor33};
		}
	}
	p.para {
		margin: 0px;
		font-weight: 400;
		font-size: 12px;
		line-height: 20px;
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.colors.themeColor33};
	}
`;
export const XThemeVoiceAssTableCard = styled(Card)`
	width: 100%;
	position: relative;
	.ant-card-body {
		padding: 0px;
	}
	.tableTitle {
		font-weight: 400;
		font-size: 16px;
		line-height: 18px;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
	.hasPadding {
		width: 100%;
		position: relative;
		padding: 24px;
	}
	.cardTitle {
		font-weight: 500;
		font-size: 14px;
		line-height: 20px;
		color: ${({ theme }) => theme.colors.themeColor1};
		span.details1 {
			font-weight: 400;
			margin-left: 10px;
			&::before {
				content: '• ';
			}
		}
		span.details2 {
			font-weight: 400;
			font-size: 12px;
			line-height: 20px;
			line-height: 20px;
			.icons {
				margin-right: 10px;
			}
		}
	}
	.instructionsTitle {
		background: ${({ theme }) => theme.colors.bodyBg};
		font-weight: 500;
		font-size: 12px;
		line-height: 20px;
		color: ${({ theme }) => theme.colors.themeColor1};
		padding: 10px 24px;
	}
	ul.listData1 {
		margin: 0px;
		padding: 0px;
	}
	ul.listData1 li {
		margin-left: 15px;
		display: list-item;
		list-style-type: disc;
		font-weight: 400;
		font-size: 12px;
		line-height: 24px;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
	.thanksTitle {
		font-weight: 500;
		font-size: 16px;
		line-height: 24px;
		text-align: center;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
	&.fixedHeight {
		overflow: hidden;
		height: 280px;
	}
`;
export const XThemeVoiceAssSeeBtn = styled(Button)`
	width: 100%;
	position: relative;
	border: 1px solid rgba(33, 34, 38, 0.1);
	border-radius: 10px;
	padding: 0px 20px !important;
	height: 44px !important;
	font-weight: 400;
	font-size: 14px;
	line-height: 14px;
	color: ${({ theme }) => theme.colors.themeColor1};
	@media only screen and (max-width: 991px) {
		padding: 10px 13px !important;
		height: auto !important;
		font-size: 12px;
		line-height: 13px;
		-webkit-tap-highlight-color: transparent;
		touch-action: manipulation;
		&:active {
			opacity: 0.7;
			transform: scale(0.98);
		}
	}
	img {
		margin-right: 8px;
		width: 65%;
		filter: brightness(0) saturate(100%) invert(12%) sepia(1%)
			saturate(4156%) hue-rotate(189deg) brightness(90%) contrast(94%);
		@media only screen and (max-width: 991px) {
			width: 100%;
		}
	}
	&:hover {
		background: linear-gradient(
			90deg,
			${({ theme }) => theme.colors.themeColor8} 20.31%,
			${({ theme }) => theme.colors.themeColor25} 100%
		) !important;
		color: ${({ theme }) => theme.colors.white} !important;
		border-color: ${({ theme }) => theme.colors.white} !important;
		img {
			filter: brightness(0) saturate(100%) invert(94%) sepia(25%)
				saturate(2%) hue-rotate(12deg) brightness(110%) contrast(100%);
		}
	}
`;
export const XThemeVoiceAssTable = styled(Table)`
	width: 100%;
	position: relative;
	.ant-table-cell {
		font-style: normal;
		font-weight: 500 !important;
		font-size: 12px;
		line-height: 16px;
		text-transform: uppercase;
		background: ${({ theme }) => theme.CQColors.bodyBg} !important;
		color: ${({ theme }) => theme.CQColors.themeColor2} !important;
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		border-radius: 0px !important;
		a {
			font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
			color: ${({ theme }) => theme.CQColors.themeColor2} !important;
			text-decoration: underline;
		}
		/* &:first-child {
			border-radius: 15px 0px 0px 0px !important;
		}
		&:last-child {
			border-radius: 0px 15px 0px 0px !important;
		} */
	}
	td.ant-table-cell {
		text-transform: capitalize;
		font-weight: 400 !important;
		font-size: 12px;
		background: ${({ theme }) => theme.colors.white} !important;
		color: ${({ theme }) => theme.colors.themeColor5} !important;
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		&:first-child {
			border-radius: 0px !important;
		}
		&:last-child {
			border-radius: 0px !important;
		}
	}
	.tablecount {
		width: 30px !important;
		height: 30px;
		border-radius: 30px;
		line-height: 30px;
		text-align: center;
		text-transform: uppercase;
		background: rgba(224, 230, 236, 1);
		border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
		box-shadow: inset 0px 16.8313px 16.8313px rgba(255, 255, 255, 0.8);
	}
	.tablecountStd {
		width: 40px !important;
		height: 30px;
		background: #f4f6f9;
		border-radius: 5px;
		line-height: 30px;
		text-align: center;
	}

	/* Table triangle Status */
	td.custom-border-left {
		padding: 0 !important;
	}

	td > .triangle {
		display: grid;
		place-items: center;
		position: absolute;
		top: 0;
	}

	td > .in_process {
		border-right: 20px solid transparent;
		border-top: 20px solid #1f9254 !important;
	}

	td > .untimely {
		border-right: 20px solid transparent;
		border-top: 20px solid #db3a17 !important;
	}

	td > .escalation {
		border-right: 20px solid transparent;
		border-top: 20px solid #e57711 !important;
	}

	td > .at_risk {
		border-right: 20px solid transparent;
		border-top: 20px solid #e5aa11 !important;
	}
	/* Make rows bold when status is human_intervention */
	tr.processing {
		td,
		td a {
			font-weight: 700 !important;
		}
	}
	.staticTag {
		position: absolute;
		top: 30%;
		left: 30%;
		padding: 0px 10px !important;
		background: ${({ theme }) => theme.colors.bodyBg} !important;
		color: ${({ theme }) => theme.colors.themeColor5} !important;
		&:before {
			display: none !important;
			content: '' !important;
		}
	}

	// Add these status color styles
	.successful,
	.approved {
		background: #e1fcef !important;
		color: #14804a !important;
	}

	.rejected {
		background: #fff1f0 !important;
		color: #cf1322 !important;
	}

	.pending,
	.pending_for_analysis {
		background: #fde9cb !important;
		color: #e78900 !important;
	}

	.allocated {
		background: #ffe9da !important;
		color: #7a0e27 !important;
		border-color: #b7eb8f;
	}

	.analysed {
		background: #fffcda !important;
		color: #7a670e !important;
	}

	.letter_created {
		background: #fffcda !important;
		color: #7a670e !important;
	}

	.letter_sent {
		border-radius: 5px;
		border: 0.5px solid rgba(56, 160, 108, 0.3);
		background: #e1fcef;
		box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
		color: #38a06c;
	}
`;
export const XThemeVoiceaAssSearchBar = styled.div`
	width: 100%;
	position: relative;
	input {
		background: ${({ theme }) => theme.colors.white} !important;
		border-radius: 40px;
		height: auto !important;
		padding: 15px 20px;
		&:hover,
		&:focus {
			border: 1px solid ${({ theme }) => theme.colors.themeColor22} !important;
			box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1) !important;
		}
	}
	/* button {
		background: linear-gradient(
			135deg,
			#007299 0%,
			#7ee6e9 100%
		) !important;
		width: 53px !important;
		height: 53px !important;
		border-radius: 53px;
		transition: all 0.3s ease-in-out;
	}
	.ant-btn-loading {
		&::after {
			content: '';
			position: absolute;
			width: 120%;
			height: 120%;
			border-radius: 50%;
			background: radial-gradient(circle, #007299 30%, #7ee6e9 80%);
			animation: pulse 2s infinite ease-in-out;
		}
		@keyframes pulse {
			0% {
				transform: scale(1);
				opacity: 0.7;
			}
			50% {
				transform: scale(1.2);
				opacity: 0.4;
			}
			100% {
				transform: scale(1);
				opacity: 0.7;
			}
		}
	} */
`;
export const XThemeVoiceaAsistChatCard = styled(Card)`
	width: 100%;
	position: relative;
	height: 100%;
	background: linear-gradient(
		180deg,
		rgba(255, 255, 255, 0.5) 0%,
		rgba(216, 239, 244, 0.5) 100%
	);
	border: none;
	border-radius: 0px 0px 0px 30px;
	height: calc(100vh - 80px);
	.ant-card-body {
		height: 100%;
	}
	.asistCardTitle {
		background: linear-gradient(180deg, #212226 0%, #007299 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
		text-fill-color: transparent;
		font-weight: 400;
		font-size: 28px;
		line-height: 42px;
	}
	.chatWrapper {
		width: 100%;
		position: relative;
		height: 100vh;
		.cardSuggestions {
			display: flex;
			flex-direction: column;
			min-height: 100%;
			overflow-y: auto;
			height: 100%;
			h3 {
				margin: 0px;
				font-weight: 500;
				font-size: 16px;
				line-height: 20px;
				text-align: center;
				color: ${({ theme }) => theme.colors.themeColor1};
			}
			p {
				margin: 0px;
				font-weight: 400;
				font-size: 14px;
				line-height: 20px;
				text-align: center;
				color: ${({ theme }) => theme.colors.themeColor33};
				margin-bottom: 7px;
			}
		}
	}
	.chatFooter {
		width: 94%;
		position: absolute;
		bottom: 0px;
		margin: 0px auto;
	}
`;
// export const XThemeVSChatBar = styled.section`
// 	width: 100%;
// 	position: relative;
// 	.headerBar {
// 		position: absolute;
// 		top: -40px;
// 		left: 0;
// 		right: 0%;
// 		background: transparent;
// 		z-index: 1;
// 	}
// 	.scrollWrapper {
// 		width: 100%;
// 		position: relative;
// 		background: transparent;
// 		.textChat {
// 			width: 98%;
// 			position: relative;
// 			.textChatContainer {
// 				display: block;
// 				background: ${({ theme }) => theme.colors.white};
// 				border-radius: 10px;
// 				border: 1px solid rgba(33, 34, 38, 0.05);
// 				margin-bottom: 5px;
// 				padding: 10px;
// 				height: 100%;
// 				overflow: auto;
// 				.textChatImage {
// 					width: 35px;
// 					float: left;
// 					min-height: 100%;
// 					img {
// 						max-width: 30px;
// 						max-height: 30px;
// 					}
// 				}
// 				.textChatText {
// 					margin-top: 2px;
// 					float: right;
// 					width: calc(100% - 40px);
// 					word-wrap: break-word;
// 					font-weight: 400;
// 					font-size: 13px;
// 					line-height: 20px;
// 					color: ${({ theme }) => theme.colors.themeColor1};
// 					white-space: pre-wrap; /* Add this line to preserve spacing */
// 					text-align: left; /* Add this line to ensure left alignment */
// 					ol,
// 					ul {
// 						padding-left: 20px !important;
// 					}
// 					ul.systemList {
// 						margin: 0px;
// 						padding: 0px;

// 						li {
// 							list-style-type: decimal;
// 							margin-left: 20px;
// 							margin-bottom: 3px;
// 							ul {
// 								margin: 5px 0px 0px 20px;
// 								padding: 0px;
// 								li {
// 									list-style-type: disc;
// 									margin-left: 0px;
// 									ul {
// 										margin: 0px;
// 										padding: 0px;
// 										li {
// 											list-style-type: disc;
// 											margin-left: 15px;
// 										}
// 									}
// 								}
// 							}
// 						}
// 					}
// 					ul.systemListIcon {
// 						margin: 7px 0;
// 						padding-left: 0px !important;
// 						li {
// 							display: list-item;
// 							list-style-type: none;
// 							margin-bottom: 4px;
// 							padding-left: 25px;
// 							&.icon1 {
// 								background: url('/images/chat-system-icon-1.svg')
// 									no-repeat left center;
// 							}
// 							&.icon2 {
// 								background: url('/images/chat-system-icon-2.svg')
// 									no-repeat left center;
// 							}
// 							&.icon3 {
// 								background: url('/images/chat-system-icon-3.svg')
// 									no-repeat left center;
// 							}
// 						}
// 					}
// 					ul.systemListCheckbox {
// 						margin: 7px 0;
// 						padding-left: 0px !important;
// 						li {
// 							display: list-item;
// 							list-style-type: none;
// 							margin-bottom: 4px;
// 							padding-left: 0px;
// 						}
// 					}
// 				}
// 			}
// 		}
// 		.textChat.textChat_reply {
// 			.textChatContainer {
// 				background: #eaf2f4;
// 				display: block;
// 				margin-bottom: 5px;
// 				padding: 10px;
// 				height: 100%;
// 				overflow: auto;
// 				.textChatImage {
// 					width: 35px;
// 					float: left;
// 					min-height: 100%;
// 					img {
// 						max-width: 30px;
// 						max-height: 30px;
// 					}
// 				}
// 				.textChatText {
// 					float: right;
// 					width: calc(100% - 40px);
// 					word-wrap: break-word;
// 					font-weight: 400;
// 					font-size: 13px;
// 					line-height: 20px;
// 					color: ${({ theme }) => theme.colors.themeColor1};
// 				}
// 			}
// 		}
// 	}
// `;
export const XThemeHeaderBTN = styled(Button)`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid rgba(33, 34, 38, 0.1);
	border-radius: 30px;
	padding: 10px 15px;
	font-weight: 400;
	font-size: 14px;
	line-height: 18px;
	color: ${({ theme }) => theme.colors.themeColor33};
	img {
		filter: brightness(0) saturate(100%) invert(40%) sepia(15%)
			saturate(1201%) hue-rotate(194deg) brightness(84%) contrast(97%);
	}
	&:hover {
		background: linear-gradient(
			90deg,
			${({ theme }) => theme.colors.themeColor8} 20.31%,
			${({ theme }) => theme.colors.themeColor25} 100%
		) !important;
		color: ${({ theme }) => theme.colors.white} !important;
		border-color: ${({ theme }) => theme.colors.white} !important;
		img {
			filter: brightness(0) saturate(100%) invert(94%) sepia(25%)
				saturate(2%) hue-rotate(12deg) brightness(110%) contrast(100%);
		}
	}
`;
export const XThemeVACheckbox = styled(Checkbox)`
	font-weight: 400;
	font-size: 12px;
	line-height: 20px;
	.ant-checkbox-wrapper:hover .ant-checkbox-inner {
		background: ${({ theme }) => theme.colors.themeColor8} !important;
	}
	.ant-checkbox:hover .ant-checkbox-inner {
		background: ${({ theme }) => theme.colors.themeColor8} !important;
	}
	.ant-checkbox-checked .ant-checkbox-inner {
		background: ${({ theme }) => theme.colors.themeColor8} !important;
		border-color: ${({ theme }) => theme.colors.themeColor8} !important;
	}
`;
export const XThemeVASubmitBTN = styled(Button)`
	background: ${({ theme }) => theme.colors.themeColor8};
	border: 1px solid transparent;
	border-radius: 10px;
	padding: 10px 20px;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	color: ${({ theme }) => theme.colors.white};
	@media only screen and (max-width: 991px) {
		padding: 7px 12px;
		font-weight: 400;
		font-size: 14px;
		height: auto;
		line-height: 20px;
	}
	&:hover {
		background: ${({ theme }) => theme.colors.themeColor8}!important;
		color: ${({ theme }) => theme.colors.white} !important;
		border-color: ${({ theme }) => theme.colors.white} !important;
	}
	.rotateButton {
		transform: rotate(3.142rad);
	}
	&.rotateDotButton {
		transform: rotate(90deg);
	}
	&.noBackground {
		background: ${({ theme }) => theme.colors.white} !important;
		border: 1px solid #dadee3 !important;
		border-radius: 10px !important;
		font-weight: 500 !important;
		font-size: 14px !important;
		line-height: 14px !important;
		letter-spacing: 0.02em !important;
		padding: 5px 15px !important;
		color: ${({ theme }) => theme.colors.themeColor8} !important;
		img {
			width: 80%;
			filter: brightness(0) saturate(100%) invert(20%) sepia(72%)
				saturate(3361%) hue-rotate(179deg) brightness(99%)
				contrast(101%);
		}
		&:hover {
			background: ${({ theme }) => theme.colors.themeColor8}!important;
			color: ${({ theme }) => theme.colors.white} !important;
			border-color: ${({ theme }) => theme.colors.white} !important;
			img {
				filter: brightness(0) saturate(100%) invert(100%) sepia(96%)
					saturate(0%) hue-rotate(94deg) brightness(106%)
					contrast(105%);
			}
		}
	}
	&.massages {
		cursor: default;
		background: ${({ theme }) => theme.colors.white};
		border: 1px solid ${({ theme }) => theme.colors.themeColor23};
		color: ${({ theme }) => theme.colors.themeColor33};
		&:hover {
			background: ${({ theme }) => theme.colors.white} !important;
			border: 1px solid
				${({ theme }) => theme.colors.themeColor23}!important;
			color: ${({ theme }) => theme.colors.themeColor33} !important;
		}
	}
	&.radiusBtn {
		background: ${({ theme }) => theme.colors.white} !important;
		border: 1px solid rgba(0, 114, 153, 0.1) !important;
		border-radius: 5px !important;
		font-weight: 500 !important;
		font-size: 13px !important;
		line-height: 13px !important;
		letter-spacing: 0.02em !important;
		color: ${({ theme }) => theme.colors.themeColor8} !important;
		text-align: center;
		img {
			filter: brightness(0) saturate(100%) invert(20%) sepia(72%)
				saturate(3361%) hue-rotate(179deg) brightness(99%)
				contrast(101%);
		}
		&:hover {
			background: ${({ theme }) => theme.colors.themeColor8}!important;
			color: ${({ theme }) => theme.colors.white} !important;
			border-color: ${({ theme }) => theme.colors.white} !important;
			img {
				filter: brightness(0) saturate(100%) invert(100%) sepia(96%)
					saturate(0%) hue-rotate(94deg) brightness(106%)
					contrast(105%);
			}
		}
	}
`;
export const XVSLottieWrapper = styled.div`
	position: relative;
	width: 100%;
	height: calc(100vh - 190px);
	display: flex;
	align-items: center;
	justify-content: center;
	.innerCard {
		position: relative;
		min-width: 350px;
		max-width: 100%;
		margin: 0px auto;
		background: #fff;
		border: 15px solid #e6f1f5;
		border-radius: 40px;
		padding: 20px 40px;
		&:after {
			position: absolute;
			top: -50px;
			left: 50%; /* Move it to the center */
			transform: translateX(-50%); /* Adjust it back */
			content: '';
			display: block;
			width: 114px;
			height: 51px;
			background-image: url('/images/loader_pin.svg');
			background-repeat: no-repeat;
			background-position: center; /* Centers the background */
			background-size: contain; /* Ensures the image fits */
			@media only screen and (max-width: 511.99px) {
			}
		}
		ul {
			margin: 0px;
			padding: 0px;
			min-height: 285px;
		}
		ul li {
			display: list-item;
			list-style-type: none;
			font-weight: 500;
			font-size: 14px;
			line-height: 30px;
			margin-bottom: 20px;
			padding-left: 20px;
			align-items: center;
			display: flex;
			@media only screen and (max-width: 511.99px) {
				line-height: 16px;
			}
			&:last-child {
				margin-bottom: 0px;
			}
			span {
				position: absolute;
				left: 15px;
				width: 30px;
				height: 30px;
				border-radius: 30px;
				text-align: center;
				@media only screen and (max-width: 511.99px) {
					line-height: 30px;
				}
			}
			span.status-icon {
				position: absolute;
				right: 15px !important;
				left: auto !important;
				width: 30px;
				height: 30px;
				border-radius: 30px;
				text-align: center;
				@media only screen and (max-width: 511.99px) {
					line-height: 30px;
				}
				background: transparent !important;
			}
		}
		ul li.active {
			color: #008542;
			transition: color 3s;
			span {
				background: #008542;
				transition: background-color 3s;
			}
		}
		ul li.inprocess {
			color: #e5aa11;
			transition: color 3s;
			span {
				background: #e5aa11;
				transition: background-color 3s;
			}
		}
	}
`;
export const XVSLottie = styled(Lottie)`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	z-index: 0;
	background: transparent;
	&.relativePositions {
		position: relative !important;
		left: auto !important;
		top: auto !important;
		max-width: 350px !important;
		margin: 0px auto;
		&.thanksJson {
			max-width: 200px !important;
		}
	}
`;
export const XThemeVSCollapse = styled(Collapse)`
	width: 100%;
	position: relative;
	background: transparent;
	.ant-collapse-header {
		background: #f4f6f9 !important;
		border: 1px solid rgba(33, 34, 38, 0.05);
		border-radius: 10px !important;
		.ant-collapse-header-text {
			font-weight: 500 !important;
			font-size: 14px !important;
			line-height: 24px !important;
			color: ${({ theme }) => theme.colors.themeColor1};
		}
	}
	.ant-collapse-item-active {
		.ant-collapse-header {
			border-radius: 10px 10px 0px 0px !important;
			border-bottom: 0px;
		}
	}
	.ant-collapse-item {
		margin-bottom: 10px;
		border-bottom: none;
	}
	.ant-collapse-content {
		background: #f4f6f9 !important;
		border: 1px solid rgba(33, 34, 38, 0.05);
		border-radius: 0px 0px 10px 10px !important;
	}
	.ant-collapse {
		background: transparent !important;
	}
	.ant-collapse-expand-icon {
		span {
			background: ${({ theme }) => theme.colors.white};
			color: ${({ theme }) => theme.colors.themeColor1};
			border-radius: 50%;
			text-align: center;
			padding: 8px;
			font-size: 16px;
		}
	}
`;
export const XThemeVSDetailsCard = styled(Card)`
	width: 100%;
	position: relative;
	background: #f4f6f9;
	border: 1px solid rgba(33, 34, 38, 0.05);
	border-radius: 10px;
	margin-bottom: 15px;
	transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
	&.isExpanded {
		max-height: 180px;
		overflow: hidden;
	}
	&.noSpaceCard {
		border-radius: 0px;
		border: 0px;
		padding: 0px 15px;
		.para {
			margin: 0px;
			font-weight: 400;
			font-size: 14px;
			line-height: 20px;
			color: #57636f;
			span {
				font-weight: 500;
				color: ${({ theme }) => theme.colors.themeColor1};
				margin-right: 10px;
			}
		}
	}
	.ant-card-body {
		padding: 15px;
	}
	.tagsView {
		background: ${({ theme }) => theme.colors.white};
		border-radius: 10px;
		padding: 7px 10px;
		font-weight: 500;
		font-size: 12px;
		line-height: 20px;
		text-align: center;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
	.titleHead1 {
		font-weight: 500 !important;
		font-size: 14px;
		line-height: 20px;
		color: ${({ theme }) => theme.colors.themeColor1};
		span {
			font-weight: 400 !important;
			margin-left: 10px;
			&::before {
				content: '• ';
			}
		}
	}
	.titleHead2 {
		font-weight: 400 !important;
		font-size: 14px;
		line-height: 20px;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
	.titleHead3 {
		font-weight: 400 !important;
		font-size: 12px;
		line-height: 20px;
		color: ${({ theme }) => theme.colors.themeColor1};
		svg {
			margin-right: 10px;
		}
	}
	.para1 {
		margin: 0px;
		font-weight: 400;
		font-size: 13px;
		line-height: 20px;
		color: ${({ theme }) => theme.colors.themeColor1};
		span {
			font-weight: 500;
			font-size: 12px;
			line-height: 20px;
			color: ${({ theme }) => theme.colors.themeColor33};
		}
	}
`;
export const XThemeVSSetViewPort = styled.div`
	display: flex;
	height: calc(100vh - 80px);
	/* padding: 20px; */
	/* gap: 20px; */
	&.displyBlock {
		display: block;
		height: calc(100vh - 105px) !important;
	}
	@media only screen and (max-width: 992px) {
	}
`;
export const XThemeVSScrollContainer = styled.div`
	padding: 10px;
	/*border: 1px solid #ccc;
	border-radius: 10px; */
	height: 100%;
	overflow-y: auto; /*Enables scrolling */
	position: relative; /* Required for sticky to work */
	/* &:hover {
		overflow-y: auto;
	} */
	&::-webkit-scrollbar {
		width: 1px;
		height: 1px;
		border: transparent;
	}
	&::-webkit-scrollbar-track {
		border-radius: 0px;
		background: ${({ theme }) => theme.colors.themeColor22};
	}
	&::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background: ${({ theme }) => theme.colors.themeColor8};
	}
`;
export const XThemeVSDetailsFooter = styled.section`
	position: sticky;
	bottom: -10px;
	width: 100%;
	background: ${({ theme }) => theme.colors.white};
	padding: 15px;
	border-top: 1px dashed ${({ theme }) => theme.colors.themeColor22};
	border-radius: 0px 0px 10px 10px;
`;
export const XThemeVSGenerateAL = styled.div`
	width: 100%;
	position: relative;
	height: 100%;
`;
export const XThemeVSPara1 = styled.p`
	font-weight: 400;
	font-size: 13px;
	line-height: 22px;
	margin-bottom: 15px;
	color: ${({ theme }) => theme.colors.themeColor1};
`;
export const XThemeVSSumInnerCard = styled(Card)`
	background: ${({ theme }) => theme.colors.white};
	border-radius: 10px;
	border: none;
	.ant-card-body {
		padding: 15px;
	}
	p.cardPara {
		margin: 0px;
		font-weight: 400;
		font-size: 13px;
		line-height: 20px;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
	.headerBorder {
		padding-bottom: 10px;
		margin-bottom: 15px;
		border-bottom: 1px dashed ${({ theme }) => theme.colors.themeColor22};
	}
`;
export const XThemeVSSumListCard = styled(Card)`
	background: ${({ theme }) => theme.colors.white};
	border-radius: 10px;
	border: 1px solid rgba(87, 99, 111, 0.15);
	.ant-card-body {
		padding: 0px 15px !important;
	}
	.para1 {
		margin: 0px;
		font-weight: 400;
		font-size: 13px;
		line-height: 24px;
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.colors.themeColor1};
		padding: 10px 0px;
		span {
			font-weight: 500;
		}
	}
	.para2 {
		margin: 0px;
		font-weight: 500;
		font-size: 13px;
		line-height: 24px;
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.colors.themeColor8};
		padding: 15px 0px;
	}
	a {
		font-weight: 400;
		font-size: 13px;
		line-height: 24px;
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
`;
export const XThemeSentToTabs = styled(Tabs)`
	.ant-tabs {
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
	}
	.ant-tabs-nav::before {
		display: none;
	}
	.ant-tabs-content-holder {
		@media only screen and (max-width: 768px) {
		}
	}
	.ant-tabs-tab {
		border-radius: 10px !important;
		border: 1px solid ${({ theme }) => theme.colors.themeColor8}!important;
		background: ${({ theme }) => theme.colors.white} !important;
		padding: 8px 24px !important;
		margin-right: 10px !important;
		&:hover {
			background: ${({ theme }) => theme.colors.themeColor8} !important;
			.ant-tabs-tab-btn {
				color: ${({ theme }) => theme.colors.white} !important;
			}
		}
		.ant-tabs-tab-btn {
			font-weight: 400;
			font-size: 14px;
			line-height: 20px;
			letter-spacing: -0.02em;
			color: ${({ theme }) => theme.colors.themeColor8};
		}
		.ant-tag {
			margin-left: 10px !important;
			margin-right: 0px !important;
			background: #e1edf2;
			border-radius: 10px;
			border: transparent;
			color: ${({ theme }) => theme.colors.themeColor1};
		}
	}
	.ant-tabs-tab-active {
		background: ${({ theme }) => theme.colors.themeColor8} !important;
		.ant-tabs-tab-btn {
			color: ${({ theme }) => theme.colors.white} !important;
		}
	}
	@media only screen and (max-width: 768px) {
	}
`;
export const XThemeVARadio = styled(Radio)`
	margin-top: 10px;
	color: ${({ theme }) => theme.colors.themeColor1};
	font-weight: 500;
	font-size: 13px !important;
	line-height: 28px !important;
	.ant-form-item-control-input {
		min-height: auto !important;
	}
	.ant-radio-checked .ant-radio-inner {
		background: ${({ theme }) => theme.colors.themeColor8};
		border-color: ${({ theme }) => theme.colors.themeColor8};
	}
	&.ant-radio-wrapper-checked {
		span {
			color: ${({ theme }) => theme.colors.themeColor8} !important;
		}
	}
`;
export const XThemeVATextArea = styled(TextArea)`
	width: 100%;
	position: relative;
	background: ${({ theme }) => theme.colors.white} !important;
	border: 1px solid ${({ theme }) => theme.colors.themeColor23} !important;
	border-radius: 10px !important;
	font-weight: 400 !important;
	font-size: 14px !important;
	line-height: 100% !important;
	color: ${({ theme }) => theme.colors.themeColor1} !important;
	resize: none;
	&:hover,
	&:focus {
	}
	&.addBackground {
		background: ${({ theme }) => theme.colors.bodyBg} !important;
		border: 1px solid ${({ theme }) => theme.colors.bodyBg} !important;
		border-radius: 8px !important;
		padding: 10px 15px !important;
		resize: none;
	}
`;
export const XThemeVSShareBTN = styled(Button)`
	width: 100%;
	position: relative;
	background: ${({ theme }) => theme.colors.bodyBg};
	border: 1px solid rgba(33, 34, 38, 0.1);
	border-radius: 10px;
	display: block;
	height: 100%;
	padding: 10% !important;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	color: ${({ theme }) => theme.colors.themeColor1};
	img {
		margin-bottom: 10px;
		filter: brightness(0) saturate(100%) invert(19%) sepia(99%)
			saturate(2489%) hue-rotate(178deg) brightness(101%) contrast(101%);
	}
	&:hover {
		background: ${({ theme }) => theme.colors.themeColor8} !important;
		color: ${({ theme }) => theme.colors.white} !important;
		border-color: ${({ theme }) => theme.colors.white} !important;
		img {
			filter: brightness(0) saturate(100%) invert(94%) sepia(25%)
				saturate(2%) hue-rotate(12deg) brightness(110%) contrast(100%);
		}
	}
`;
export const XThemeVAAction = styled(Button)`
	background: linear-gradient(135deg, #007299 0%, #7ee6e9 100%) !important;
	width: 53px !important;
	height: 53px !important;
	border-radius: 53px;
	transition: all 0.3s ease-in-out;
`;
export const StyledWrapper = styled.div`
	background: linear-gradient(135deg, #007299 0%, #7ee6e9 100%) !important;
	width: 53px !important;
	height: 53px !important;
	border-radius: 53px;
	transition: all 0.3s ease-in-out;
	position: absolute;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	.loader {
		--size: 53px;
		--duration: 2s;
		--logo-color: ${({ theme }) => theme.colors.themeColor1};
		--background: linear-gradient(135deg, #007299 0%, #7ee6e9 100%);
		height: var(--size);
		aspect-ratio: 1;
		position: relative;
	}

	.loader .box {
		position: absolute;
		background: rgba(100, 100, 100, 0.15);
		background: var(--background);
		border-radius: 50%;
		border-top: 1px solid ${({ theme }) => theme.colors.themeColor22};
		/* box-shadow: rgba(0, 0, 0, 0.3) 0px 10px 10px -0px; */
		/* backdrop-filter: blur(5px); */
		animation: ripple var(--duration) infinite ease-in-out;
	}
	.loader .box:nth-child(1) {
		inset: 30%;
		z-index: 99;
	}
	.loader .box:nth-child(2) {
		inset: 20%;
		z-index: 98;
		border-color: rgba(100, 100, 100, 0.8);
		animation-delay: 0.2s;
	}

	.loader .box:nth-child(3) {
		inset: 10%;
		z-index: 97;
		border-color: rgba(100, 100, 100, 0.6);
		animation-delay: 0.4s;
	}

	.loader .box:nth-child(4) {
		inset: 5%;
		z-index: 96;
		border-color: rgba(100, 100, 100, 0.4);
		animation-delay: 0.6s;
	}

	.loader .box:nth-child(5) {
		inset: 0%;
		z-index: 95;
		border-color: rgba(100, 100, 100, 0.2);
		animation-delay: 0.8s;
	}

	.loader .logo {
		position: absolute;
		inset: 0;
		display: grid;
		place-content: center;
		padding: 0%;
		z-index: 999;
		border: none !important;
	}

	/* .loader .logo img {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
	} */

	@keyframes ripple {
		0% {
			transform: scale(1);
			/* box-shadow: rgba(0, 0, 0, 0.3) 0px 10px 10px -0px; */
		}
		50% {
			transform: scale(1.3);
			/* box-shadow: rgba(0, 0, 0, 0.3) 0px 30px 20px -0px; */
		}
		100% {
			transform: scale(1);
			/* box-shadow: rgba(0, 0, 0, 0.3) 0px 10px 10px -0px; */
		}
	}
`;
export const TypingLoaderWrapper = styled.div`
	position: sticky;
	width: 30px;
	height: 15px;
	left: 5%;
	bottom: -7px;
	.typing-indicator {
		z-index: 4;
	}
	.typing-circle {
		width: 4px;
		height: 4px;
		position: absolute;
		border-radius: 50%;
		background-color: ${({ theme }) => theme.colors.themeColor8};
		left: 15%;
		transform-origin: 50%;
		animation: typing-circle7124 0.5s alternate infinite ease;
	}

	@keyframes typing-circle7124 {
		0% {
			top: 10px;
			height: 3px;
			border-radius: 50px 50px 25px 25px;
			transform: scaleX(1.7);
		}

		40% {
			height: 4px;
			border-radius: 50%;
			transform: scaleX(1);
		}

		100% {
			top: 0%;
		}
	}

	.typing-circle:nth-child(2) {
		left: 45%;
		animation-delay: 0.2s;
	}

	.typing-circle:nth-child(3) {
		left: auto;
		right: 15%;
		animation-delay: 0.3s;
	}

	.typing-shadow {
		width: 3px;
		height: 2px;
		border-radius: 50%;
		background-color: rgba(0, 0, 0, 0.2);
		position: absolute;
		top: 15px;
		transform-origin: 50%;
		z-index: 3;
		left: 15%;
		filter: blur(1px);
		animation: typing-shadow046 0.5s alternate infinite ease;
	}

	@keyframes typing-shadow046 {
		0% {
			transform: scaleX(1.5);
		}

		40% {
			transform: scaleX(1);
			opacity: 0.7;
		}

		100% {
			transform: scaleX(0.2);
			opacity: 0.4;
		}
	}

	.typing-shadow:nth-child(4) {
		left: 45%;
		animation-delay: 0.2s;
	}

	.typing-shadow:nth-child(5) {
		left: auto;
		right: 15%;
		animation-delay: 0.3s;
	}
`;

// Mobile device style
export const XThemeVAMobileWrapper = styled(Card)`
	width: 100%;
	position: relative;
	background: transparent;
	border: none;
	height: calc(100vh - 180px);
	overflow-y: auto;
	.ant-card-body {
		padding: 0px 10px 20px 10px !important;
	}
	.scrollMobileWrapper {
		/*************************/
		.textChat {
			.textChatContainer {
				margin: 0.5em auto;
				padding: 0 1em;
				display: flex;
				/* align-items: center; */
				gap: 1em;
			}
			.textChatImage img {
				border-radius: 50%;
				max-width: 35px;
			}
			.textChatText {
				background: ${({ theme }) => theme.colors.white};
				border: 1px solid rgba(33, 34, 38, 0.05);
				border-radius: 0px 10px 10px 10px;
				padding: 0.75em 1em;
				display: inline-block;
				max-width: 100%;
				word-wrap: break-word;
				font-weight: 400;
				font-size: 13px;
				line-height: 20px;
				color: ${({ theme }) => theme.colors.themeColor1};
			}
		}
		.textChat.textChat_reply {
			.textChatContainer {
				justify-content: flex-end;
			}
			.textChatImage {
				order: 2;
			}
			.textChatText {
				background: #eaf2f4;
				border: 1px solid rgba(33, 34, 38, 0.05);
				border-radius: 10px 10px 0px 10px;
				text-align: left;
				display: inline-block;
				max-width: 80%;
				word-wrap: break-word;
				font-weight: 400;
				font-size: 13px;
				line-height: 20px;
				color: ${({ theme }) => theme.colors.themeColor1};
			}
		}
	}
`;
export const XThemeVAMobileChatFix = styled.div`
	width: 100%;
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	background: transparent;
	padding: 15px;
	input {
		background: ${({ theme }) => theme.colors.white} !important;
		border-radius: 40px;
		height: auto !important;
		padding: 15px 20px;
		&:hover,
		&:focus {
			border: 1px solid ${({ theme }) => theme.colors.themeColor22} !important;
			box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1) !important;
		}
	}
	button {
		background: linear-gradient(
			135deg,
			#007299 0%,
			#7ee6e9 100%
		) !important;
		width: 53px !important;
		height: 53px !important;
		border-radius: 53px;
		transition: all 0.3s ease-in-out;
	}
`;
export const XThemeVAMobileDefaultChat = styled.div`
	width: 100%;
	position: relative;
	height: 100%;
	.defaultTitle {
		background: linear-gradient(180deg, #212226 0%, #007299 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
		text-fill-color: transparent;
		font-weight: 400;
		font-size: 24px;
		line-height: 36px;
	}
	.cardSuggestions {
		display: block;
		h3 {
			margin: 0px;
			font-weight: 500;
			font-size: 16px;
			line-height: 20px;
			text-align: center;
			color: ${({ theme }) => theme.colors.themeColor1};
		}
		p {
			margin: 0px;
			font-weight: 400;
			font-size: 14px;
			line-height: 20px;
			text-align: center;
			color: ${({ theme }) => theme.colors.themeColor33};
			margin-bottom: 7px;
		}
	}
`;
export const XThemeVAMobileChat = styled(Card)`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	border-radius: 10px;
	margin: 0px 1em;
	&.expendedCard {
		background: ${({ theme }) => theme.colors.white};
		position: fixed;
		height: calc(100vh -40px) !important;
		top: 120px;
		left: 0;
		right: 0;
		bottom: 5px;
		z-index: 111;
		-webkit-overflow-scrolling: touch;
		border: none !important;
		.ant-card-body {
			padding: 20px 15px !important;
			height: 100% !important;
			overflow: auto;
		}
		.hideOverlayAfter {
			display: none;
		}
	}
	.ant-card-body {
		padding: 10px 15px !important;
	}
	.cardMainTitle {
		margin: 0px;
		font-weight: 400;
		font-size: 16px;
		line-height: 22px;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
	.cardSubTitle {
		font-weight: 400;
		font-size: 13px;
		line-height: 18px;
		color: ${({ theme }) => theme.colors.themeColor33};
	}
`;
export const XThemeVAMobileRecent = styled(Card)`
	width: 100%;
	position: relative;
	background: ${({ theme }) => theme.colors.bodyBg};
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	border-radius: 10px;
	.recentTitle {
		font-weight: 400;
		font-size: 14px;
		line-height: 18px;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
	&.expendedCardHeader {
		position: fixed;
		top: 80px;
		left: 0;
		right: 0;
		z-index: 1;
		background: ${({ theme }) => theme.colors.white};
		border-radius: 0px;
		.ant-card-body {
			padding: 10px 15px !important;
		}
	}
`;
export const XThemeVAMobileRecentData = styled(Card)`
	width: 100%;
	position: relative;
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	border-radius: 10px;
	margin-top: 10px;
	.oddEvenNo {
		width: 100%;
		text-align: center;
		background: ${({ theme }) => theme.colors.bodyBg};
		border-radius: 10px;
		font-weight: 500;
		font-size: 12px;
		line-height: 36px;
		text-align: center;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
	.cardHeading1 {
		font-weight: 400;
		font-size: 14px;
		line-height: 18px;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
	.cardHeading2 {
		font-weight: 400;
		font-size: 12px;
		line-height: 18px;
		color: ${({ theme }) => theme.colors.themeColor1};
		span {
			margin-left: 5px;
			&::before {
				content: '• ';
			}
		}
	}
	.cardHeading3 {
		font-weight: 500;
		font-size: 12px;
		line-height: 18px;
		color: ${({ theme }) => theme.colors.themeColor33};
		span {
			font-weight: 400;
			color: ${({ theme }) => theme.colors.themeColor1};
		}
	}
`;
export const XThemeVAMobileRecentFixed = styled(Button)`
	background: ${({ theme }) => theme.colors.bodyBg} !important;
	width: 30px !important;
	height: 30px !important;
	line-height: 30px !important;
	border-radius: 25px;
	img {
		width: 85%;
	}
`;
export const XThemeVAMobileHasPadd = styled(Card)`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	border-radius: 10px;
	margin: 0px 1em;
	.cardMainTitle {
		margin: 0px;
		font-weight: 400;
		font-size: 16px;
		line-height: 22px;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
	.cardSubTitle {
		font-weight: 400;
		font-size: 13px;
		line-height: 18px;
		color: ${({ theme }) => theme.colors.themeColor33};
	}
	&.expendedCard {
		background: ${({ theme }) => theme.colors.white};
		position: fixed;
		height: calc(100vh -40px) !important;
		top: 80px;
		left: 0;
		right: 0;
		bottom: 5px;
		z-index: 111;
		-webkit-overflow-scrolling: touch;
		border: none !important;
		.ant-card-body {
			/* padding: 0px !important; */
			height: 100% !important;
			overflow: auto;
		}
		.hideOverlayAfter {
			display: none;
		}
	}
	.ant-card-body {
		padding: 0px !important;
	}
	.cardHeader {
		background: ${({ theme }) => theme.colors.bodyBg};
		padding: 7px 15px;
		font-weight: 500;
		font-size: 12px;
		line-height: 20px;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
	.customHr {
		width: 100%;
		position: relative;
		border-top: 1px dashed ${({ theme }) => theme.colors.themeColor22};
		margin: 5px 0px;
	}
	.hasPadding {
		padding: 10px 15px;
	}
	.cardTitleSmall {
		font-weight: 500;
		font-size: 13px;
		line-height: 22px;
		color: ${({ theme }) => theme.colors.themeColor1};
		span {
			font-weight: 400 !important;
			margin-left: 5px;
			&::before {
				content: '• ';
			}
		}
		em {
			font-weight: 400;
			font-style: normal;
		}
	}
	ul.listData {
		margin: 0px;
		padding: 0px;
		li {
			margin-left: 15px;
			font-weight: 400;
			font-size: 12px;
			line-height: 18px;
			color: ${({ theme }) => theme.colors.themeColor1};
		}
	}
`;
export const XVALottieMobile = styled(Lottie)`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 0;
	background: transparent;
	&.relativePositions {
		position: relative !important;
		left: auto !important;
		top: auto !important;
		max-width: 350px !important;
		margin: 0px auto;
		&.thanksJson {
			max-width: 200px !important;
		}
	}
`;
export const XVALottieMobileWrapper = styled.div`
	width: 100%;
	position: relative;
	height: 100%;
	min-height: 250px;
	padding: 45px 0px 20px 0px;
	.innerCard {
		position: relative;
		background: white;
		width: 75%;
		height: 100%;
		margin: 0px auto;
		border: 10px solid #e6f1f5;
		border-radius: 40px;
		padding: 30px 40px;

		&:after {
			position: absolute;
			top: -45px;
			left: 50%; /* Move it to the center */
			transform: translateX(-50%); /* Adjust it back */
			content: '';
			display: block;
			width: 60px;
			height: 51px;
			background-image: url('/images/loader_pin.svg');
			background-repeat: no-repeat;
			background-position: center; /* Centers the background */
			background-size: contain; /* Ensures the image fits */
		}
		ul {
			margin: 0px;
			padding: 0px;
		}
		ul li {
			display: block;
			list-style-type: none;
			font-weight: 500;
			font-size: 12px;
			line-height: 100%;
			margin-bottom: 30px;
			padding-left: 20px;
			align-items: center;
			text-align: left;
			display: flex;

			&:last-child {
				margin-bottom: 0px;
			}
			span {
				position: absolute;
				left: 15px;
				width: 30px;
				height: 30px;
				border-radius: 30px;
				text-align: center;
				@media only screen and (max-width: 511.99px) {
					line-height: 30px;
				}
			}
			span.status-icon {
				position: absolute;
				right: 15px !important;
				left: auto !important;
				width: 30px;
				height: 30px;
				border-radius: 30px;
				text-align: center;
				@media only screen and (max-width: 511.99px) {
					line-height: 30px;
				}
				background: transparent !important;
			}
		}
		ul li.active {
			color: #008542;
			transition: color 3s;
			span {
				background: #008542;
				transition: background-color 3s;
			}
		}
		ul li.inprocess {
			color: #e5aa11;
			transition: color 3s;
			span {
				background: #e5aa11;
				transition: background-color 3s;
			}
		}
	}
`;
export const XThemeVAMobileHasFooterFixed = styled(Card)`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	border-radius: 10px;
	margin: 0px 1em;
	.cardMainTitle {
		margin: 0px;
		font-weight: 400;
		font-size: 16px;
		line-height: 22px;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
	.cardSubTitle {
		font-weight: 400;
		font-size: 13px;
		line-height: 18px;
		color: ${({ theme }) => theme.colors.themeColor33};
	}
	&.expendedCard {
		background: ${({ theme }) => theme.colors.white};
		position: fixed;
		height: calc(100vh -40px) !important;
		top: 80px;
		left: 0;
		right: 0;
		bottom: 5px;
		z-index: 111;
		-webkit-overflow-scrolling: touch;
		border: none !important;
		.ant-card-body {
			/* padding: 0px !important; */
			height: 100% !important;
			overflow: auto;
		}
		.hideOverlayAfter {
			display: none;
		}
	}
	.ant-card-body {
		padding: 0px !important;
	}
	.hasPadding {
		padding: 10px 15px;
	}
	.cardBackground {
		background: ${({ theme }) => theme.colors.bodyBg};
		border: 1px solid ${({ theme }) => theme.colors.themeColor22};
		border-radius: 10px;
		padding: 15px;
		color: ${({ theme }) => theme.colors.themeColor1};
		margin-top: 15px;
		.oddEvenNo {
			width: 100%;
			text-align: center;
			background: ${({ theme }) => theme.colors.white};
			border-radius: 10px;
			font-weight: 500;
			font-size: 12px;
			line-height: 36px;
			text-align: center;
			color: ${({ theme }) => theme.colors.themeColor1};
		}
		.cardTitleSmall {
			font-weight: 500;
			font-size: 13px;
			line-height: 22px;
			color: ${({ theme }) => theme.colors.themeColor1};
			span {
				font-weight: 400 !important;
				margin-left: 5px;
				&::before {
					content: '• ';
				}
			}
			em {
				font-weight: 400;
				font-style: normal;
			}
		}
		&.notExpended {
			height: 230px;
			overflow: hidden;
		}
	}
	.para1 {
		margin: 0px;
		font-weight: 400;
		font-size: 13px;
		line-height: 20px;
		color: ${({ theme }) => theme.colors.themeColor1};
		span {
			font-weight: 500;
			font-size: 12px;
			line-height: 20px;
			color: ${({ theme }) => theme.colors.themeColor33};
		}
	}
`;
export const XVALottieMobileActionSticky = styled.div`
	width: 100%;
	position: relative;
	background: ${({ theme }) => theme.colors.white};
	position: sticky;
	bottom: 0px;
	padding: 10px 15px;
	border-radius: 0px 0px 10px 10px;
	border-top: 1px dashed ${({ theme }) => theme.colors.themeColor22};
	button.noBackground {
		padding: 8px 10px !important;
		img {
			width: 100% !important;
		}
	}
`;
export const XThemeVAMobileCollapse = styled(Collapse)`
	width: 100%;
	position: relative;
	background: transparent;
	margin-top: 10px;

	.ant-collapse-header {
		background: #f4f6f9 !important;
		border: 1px solid rgba(33, 34, 38, 0.05);
		border-radius: 10px !important;
		.ant-collapse-header-text {
			font-weight: 500 !important;
			font-size: 14px !important;
			line-height: 24px !important;
			color: ${({ theme }) => theme.colors.themeColor1};
		}
	}
	.ant-collapse-item-active {
		.ant-collapse-header {
			border-radius: 10px 10px 0px 0px !important;
			border-bottom: 0px;
		}
	}
	.ant-collapse-item {
		margin-bottom: 10px;
		border-bottom: none;
	}
	.ant-collapse-content {
		background: #f4f6f9 !important;
		border: 1px solid rgba(33, 34, 38, 0.05);
		border-radius: 0px 0px 10px 10px !important;
	}
	.ant-collapse {
		background: transparent !important;
	}
	.ant-collapse-expand-icon {
		span {
			background: ${({ theme }) => theme.colors.white};
			color: ${({ theme }) => theme.colors.themeColor1};
			border-radius: 50%;
			text-align: center;
			padding: 8px;
			font-size: 16px;
		}
	}
`;
export const XThemeVAMobileSumInnerCard = styled(Card)`
	background: white;
	border-radius: 10px;
	border: none;
	.ant-card-body {
		padding: 15px !important;
		overflow: visible !important;
	}
	p.cardPara {
		margin: 0px;
		font-weight: 400;
		font-size: 13px;
		line-height: 20px;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
	.headerBorder {
		padding-bottom: 10px;
		margin-bottom: 15px;
		border-bottom: 1px dashed ${({ theme }) => theme.colors.themeColor22};
	}
`;
export const XThemeVAMobileSumListCard = styled(Card)`
	background: ${({ theme }) => theme.colors.white};
	border-radius: 10px;
	border: 1px solid rgba(87, 99, 111, 0.15);
	.ant-card-body {
		padding: 10px 15px !important;
	}
	.para1 {
		margin: 0px;
		font-weight: 400;
		font-size: 13px;
		line-height: 24px;
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.colors.themeColor1};
		span {
			font-weight: 500;
		}
	}
	.para2 {
		margin: 0px;
		font-weight: 500;
		font-size: 13px;
		line-height: 24px;
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.colors.themeColor8};
	}
	a {
		font-weight: 400;
		font-size: 13px;
		line-height: 24px;
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
`;
export const XThemeVAMobileDropdown = styled(Dropdown)`
	font-size: 10px !important;
	.ant-dropdown-menu-item {
		font-size: 10px;
	}
`;

export const ConversationHistoryItem = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 8px 12px;
	cursor: pointer;

	&:hover {
		background-color: #f5f5f5;
	}

	.active-conversation {
		background-color: #e6f7ff;
		border-right: 3px solid #1890ff;
	}

	.title {
		max-width: 70%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.actions {
		display: flex;
		gap: 5px;
	}
`;

// Add styling for processing messages
export const ProcessingIndicator = styled.span`
	display: inline-flex;
	margin-left: 8px;

	.dot {
		background-color: #333;
		border-radius: 50%;
		width: 6px;
		height: 6px;
		margin: 0 3px;
		animation: pulse 1.5s infinite ease-in-out;
	}

	.dot:nth-child(1) {
		animation-delay: 0s;
	}

	.dot:nth-child(2) {
		animation-delay: 0.5s;
	}

	.dot:nth-child(3) {
		animation-delay: 1s;
	}

	@keyframes pulse {
		0%,
		80%,
		100% {
			transform: scale(0.8);
			opacity: 0.4;
		}
		40% {
			transform: scale(1.2);
			opacity: 1;
		}
	}
`;
export const XThemeVSActionBtn = styled(Button)`
	// background: rgba(0, 114, 153, 0.05);
	background: linear-gradient(#fff, #fff) padding-box,
		linear-gradient(60deg, #169191, #82c446) border-box !important;
	color: ${({ theme }) => theme.CQColors.themeColor1} !important;
	border: 1px solid rgba(0, 107, 185, 0.1);
	border-radius: 6px;
	margin-bottom: 5px;
	font-weight: 500;
	font-size: 12px !important;
	// color: ${({ theme }) => theme.colors.themeColor8};
	img {
		margin-bottom: 10px;
		filter: brightness(0) saturate(100%) invert(19%) sepia(99%)
			saturate(2489%) hue-rotate(178deg) brightness(101%) contrast(101%);
	}
	&:hover {
		background: linear-gradient(
			270deg,
			#169191 0%,
			#82c446 100%
		) !important;
		color: ${({ theme }) => theme.colors.white} !important;
		border-color: ${({ theme }) => theme.colors.white} !important;
		img {
			filter: brightness(0) saturate(100%) invert(94%) sepia(25%)
				saturate(2%) hue-rotate(12deg) brightness(110%) contrast(100%);
		}
	}
	&.chip-item {
		background: #fff;
		border: 1px solid #e8e8e8;
		transition: all 0.3s ease;

		&:hover {
			background: #007299;
			color: #fff;
			border-color: #007299;
		}
	}
`;

export const XThemeVSAwaiting = styled.div`
	font-weight: 500;
	font-size: 14px;
	line-height: 18px;
	color: ${({ theme }) => theme.colors.themeColor3};
	img {
		margin-right: 10px;
	}
`;
export const XVSLottieCaseCentralization = styled(Lottie)`
	width: 100%;
	position: relative;
	background: transparent;
	&.relativePositions {
		position: relative !important;
		left: auto !important;
		top: auto !important;
		max-width: 350px !important;
		margin: 0px auto;
		max-width: 400px !important;
	}
`;
export const XVSLovable = styled.div`
	width: 100%;
	position: relative;
	.scroll-container {
		height: 90px;
		overflow: hidden;
		position: relative;
		.scroll-content {
			animation: scroll 10s linear infinite;
			position: absolute;
			width: 100%;
		}
	}
	ul {
		margin: 0px;
		padding: 0px;
		list-style: none;
		li {
			text-align: center;
			margin: 0px;
			padding: 0px;
			font-weight: 400;
			font-size: 14px;
			line-height: 30px;
			height: 30px;
			color: ${({ theme }) => theme.colors.themeColor8};
			transition: color 0.3s ease, font-weight 0.3s ease,
				font-size 0.3s ease;
		}
	}
	&::after {
		position: absolute;
		width: 100%;
		height: 100%;
		/* background: rgb(255, 255, 255, 0.5); */
		content: '';
		z-index: 100;
		top: 20px;
		background: linear-gradient(
			to bottom,
			rgba(255, 255, 255, 0.4) 0%,
			rgba(255, 255, 255, 1) 100%
		);
	}
	@keyframes scroll {
		0% {
			transform: translateY(0);
		}
		100% {
			transform: translateY(-${3 * 30}px);
		}
	}
`;

// Add this to your VoiceAssistanceStyle.js file
export const ChipsWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin-bottom: 10px;

	.chip-item {
		margin: 0;
		font-size: 13px !important;
		padding: 4px 12px;
		height: auto;
		white-space: nowrap;
	}

	.loadingChips {
		width: 100%;
		padding: 8px;
		color: ${({ theme }) => theme.colors.themeColor3};
		font-size: 14px;
	}
`;
export const XThemeVAViewHiddenBTN = styled(Button)`
	margin-top: 10px;
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid rgba(33, 34, 38, 0.1);
	box-shadow: 0px 0px 8px rgba(0, 114, 153, 0.1);
	border-radius: 20px;
	font-weight: 500;
	font-size: 12px;
	line-height: 20px;
	text-align: center;
	color: ${({ theme }) => theme.colors.themeColor33};
	.iconRotate {
		rotate: 270deg;
	}
	.iconRotateDefault {
		rotate: 90deg;
	}
	img {
		width: 80%;
		filter: brightness(0) saturate(100%) invert(12%) sepia(1%)
			saturate(4156%) hue-rotate(189deg) brightness(90%) contrast(94%);
		@media only screen and (max-width: 991px) {
			width: 100%;
		}
	}
	&:hover {
		background: ${({ theme }) => theme.colors.themeColor8} !important;
		color: ${({ theme }) => theme.colors.white} !important;
		border-color: ${({ theme }) => theme.colors.white} !important;
		img {
			filter: brightness(0) saturate(100%) invert(94%) sepia(25%)
				saturate(2%) hue-rotate(12deg) brightness(110%) contrast(100%);
		}
	}
`;

export const XThemeVAOrgTitle = styled.h2`
	margin: 0px;
	font-weight: 500 !important;
	font-size: 14px !important;
	line-height: 20px !important;
	color: ${({ theme }) => theme.colors.themeColor1};
	span {
		margin-left: 10px;
		font-weight: 400;
		font-size: 12px;
		line-height: 18px;
		color: ${({ theme }) => theme.colors.themeColor33};
	}
	&.orgTitleDisable {
		color: ${({ theme }) => theme.colors.themeColor3};
	}
`;
export const XThemeVATag = styled(Tag)`
	font-family: ${({ theme }) => theme.CQColors.fontInter};
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	letter-spacing: 0.36px;
	padding-left: 18px;
	border-radius: 4px;
	&:before {
		content: '■';
		position: absolute;
		top: 0px;
		left: 5px;
		font-size: 10px;
	}
	&.rejectedTag {
		border: 1px solid rgba(183, 35, 35, 0.1);
		background-color: ${({ theme }) => theme.colors.white};
		color: #b72323 !important;
	}
	&.awaitingTag {
		border: 1px solid rgba(183, 35, 35, 0.1);
		background-color: ${({ theme }) => theme.colors.white};
		color: #008542 !important;
	}
`;
export const XThemeVAInlineBTN = styled(Button)`
	background: transparent;
	border: none;
	box-shadow: none;
	border-radius: 0px;
	font-weight: 500;
	font-size: 12px;
	line-height: 20px;
	text-align: center;
	padding: 0px;
	color: ${({ theme }) => theme.colors.themeColor8};
	/* img {
		width: 80%;
		filter: brightness(0) saturate(100%) invert(12%) sepia(1%)
			saturate(4156%) hue-rotate(189deg) brightness(90%) contrast(94%);
		
	} */
	&:hover {
		background: transparent !important;
		color: ${({ theme }) => theme.colors.themeColor8} !important;
		border-color: none !important;
		/* img {
			filter: brightness(0) saturate(100%) invert(94%) sepia(25%)
				saturate(2%) hue-rotate(12deg) brightness(110%) contrast(100%);
		} */
	}
	&.borderView {
		border: 1px solid rgba(0, 114, 153, 0.1);
		border-radius: 6px;
		padding: 5px 10px;
		&:hover {
			background: ${({ theme }) => theme.colors.themeColor8} !important;
			color: ${({ theme }) => theme.colors.white} !important;
			border-color: ${({ theme }) => theme.colors.themeColor8} !important;
		}
	}
`;
export const XThemeVACountSteps = styled.div`
	width: 100%;
	position: relative;
	margin-top: 10px;
	font-size: 14px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.themeColor8};
`;
export const XThemeVANextPrevBTN = styled(Button)`
	background: ${({ theme }) => theme.colors.themeColor8};
	color: ${({ theme }) => theme.colors.white};
	border-radius: 10px;
	font-style: normal;
	font-weight: 400;
	padding: 8px 20px !important;
	height: auto !important;
	font-size: 14px;
	&:hover {
		background: ${({ theme }) => theme.colors.themeColor8} !important;
		color: ${({ theme }) => theme.colors.white} !important;
		border-color: ${({ theme }) => theme.colors.themeColor8} !important;
	}
	&.noBackground {
		background: transparent;
		color: ${({ theme }) => theme.colors.themeColor8};
		border: 1px solid ${({ theme }) => theme.colors.themeColor8};
		&:hover {
			background: ${({ theme }) => theme.colors.themeColor8} !important;
			color: ${({ theme }) => theme.colors.white} !important;
			border-color: ${({ theme }) => theme.colors.themeColor8} !important;
		}
	}
`;
export const XThemeVAStepTitle = styled.div`
	font-size: 18px;
	line-height: 24px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.themeColor1};
	span {
		font-size: 14px;
		line-height: 20px;
		font-weight: 400;
		color: #40444c;
	}
`;

export const XThemeVAInput = styled(Input)`
	background: ${({ theme }) => theme.colors.bodyBg} !important;
	border: 1px solid ${({ theme }) => theme.colors.bodyBg};
	border-radius: 8px;
	border: 1px solid transparent !important;
	font-size: 14px;
	line-height: 24px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.themeColor1};
	&:focus,
	&:hover {
		border-color: ${({ theme }) => theme.colors.themeColor3};
	}
	&.backgroundInput {
		background: ${({ theme }) => theme.colors.white} !important;
		border: 1px solid ${({ theme }) => theme.colors.themeColor23} !important;
		border-radius: 5px !important;
	}
`;
export const XThemeVASelect = styled(Select)`
	.ant-select-selector {
		background: ${({ theme }) => theme.colors.bodyBg} !important;
		border: transparent !important;
		box-shadow: none;
		border-radius: 8px !important;
		color: ${({ theme }) => theme.colors.menu2};
		font-size: 14px !important;
		font-style: normal;
		font-weight: 400 !important;
		line-height: 24px;
		height: 45px !important;
		line-height: 40px;
	}
	.ant-select-arrow {
		margin-top: -1px !important;
	}
	&.noBackground {
		.ant-select-selector {
			background: transparent !important;
			border: 1px solid ${({ theme }) => theme.colors.themeColor33} !important;
			box-shadow: none;
			border-radius: 8px !important;
			color: ${({ theme }) => theme.colors.menu2};
			font-size: 12px !important;
			font-style: normal;
			font-weight: 400 !important;
			height: 40px !important;
			line-height: 40px;
		}
	}
`;
export const XThemeVASelectDatePicker = styled(DatePicker)`
	width: 100%;
	position: relative;
	background: ${({ theme }) => theme.colors.bodyBg} !important;
	border: transparent !important;
	box-shadow: none;
	border-radius: 8px !important;
`;

// export const ThinkingText = styled.div`
//   color: #007299;
//   animation: pulse 1.5s ease-in-out infinite;

//   @keyframes pulse {
//     0%, 100% { opacity: 0.6; }
//     50% { opacity: 1; }
//   }
// `;

export const ThinkingText = styled.div`
	/* background: linear-gradient(90deg, #007299 0%, #7ee6e9 50%, #007299 100%); */
	background-image: linear-gradient(
		110deg,
		#202020,
		35%,
		#cdcdcd,
		50%,
		#202020,
		75%,
		#202020
	);
	background-size: 200% auto;
	-webkit-background-clip: text;
	background-clip: text;
	-webkit-text-fill-color: transparent;
	text-fill-color: transparent;
	animation: shine 2s linear infinite;
	@keyframes shine {
		to {
			background-position: -200% center;
		}
	}
`;
export const XThemeVAUploadWrap = styled.div`
	display: flex;
	justify-content: start;
	.ant-upload {
		display: flex;
		flex-wrap: wrap;
		gap: 32px;
		align-items: center;
		justify-content: center;
	}

	.ant-upload-list {
		display: flex;
		flex-wrap: wrap;
		gap: 32px;
		margin: 0;
		padding: 0;
		justify-content: center;
	}

	.ant-upload-list-item,
	.ant-upload-list-item-container,
	.ant-upload-select {
		width: 100px !important;
		height: 100px !important;
		margin: 0 !important;
		background: ${({ theme }) => theme.colors.white};
		border: 1px solid #d1d7e5;
		box-shadow: inset 0px -5px 2px #eeeff7;
		border-radius: 10px !important;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: box-shadow 0.2s;
	}

	.ant-upload-list-item .ant-upload-list-item-thumbnail img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.ant-upload-list-item .ant-upload-list-item-actions {
		position: absolute;
		top: 35%;
		right: 10px;
	}
`;
export const XThemeVAUpload = styled(Upload)`
	width: auto;
`;
export const XThemeVAUploadBtn = styled(Button)`
	width: 100px !important;
	height: 100px !important;
	position: relative;
	text-align: center;
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid #d1d7e5;
	box-shadow: inset 0px -5px 2px #eeeff7;
	border-radius: 10px !important;
	display: flex;
	align-items: center;
	justify-content: center;
	svg {
		font-size: 40px;
		display: inline-block;
		background: #007299;
		color: #ffffff !important;
		fill: #ffffff !important;
		padding: 8px;
		border-radius: 10px;
	}
`;
export const XThemeVAReferencesCard = styled(Card)`
	background: ${({ theme }) => theme.colors.bodyBg};
	border: 1px solid rgba(33, 34, 38, 0.05);
	border-radius: 10px;
	.ant-card-body {
		padding: 15px 24px;
	}
`;

export const XThemeVABatchProgressCard = styled.div`
	width: 100%;
	position: relative;
	overflow-x: auto;
	white-space: nowrap;
	padding-bottom: 10px;
	scroll-behavior: smooth;

	&::-webkit-scrollbar {
		width: 2px;
		height: 2px;
		background: ${({ theme }) => theme.colors.bodyBg} !important;
		visibility: hidden;
		transition: visibility 0.3s ease;
	}
	&::-webkit-scrollbar {
		width: 1px;
		height: 1px;
		background: transparent !important;
	}
	&::-webkit-scrollbar-thumb {
		background: ${({ theme }) => theme.colors.themeColor8} !important;
		visibility: hidden;
		transition: visibility 0.3s ease;
	}

	&:hover {
		&::-webkit-scrollbar {
			visibility: visible;
		}

		&::-webkit-scrollbar-thumb {
			visibility: visible;
		}
	}

	.ant-card-body {
		min-width: 110px;
		max-width: 150px;
		display: inline-block;
		margin-right: 16px;
		vertical-align: top;
	}
`;

export const XThemeVASelectButton = styled(Select)`
	&& .ant-select-selector {
		background: #fff !important;
		border-radius: 16px !important;
		font-weight: 600 !important;
		font-size: 14px !important;
		line-height: 30px !important;
		color: ${({ theme }) => theme.CQColors.themeColor1} !important;
		transition: all 0.35s !important;
		min-height: 36px !important;
		border: 1.5px solid ${({ theme }) => theme.CQColors.themeColor8} !important;
		box-shadow: none !important;
		padding: 0 18px 0 18px !important;
		display: flex !important;
		align-items: center !important;
		height: 40px !important;
		cursor: pointer;
	}

	&& .ant-select-selection-placeholder {
		color: ${({ theme }) => theme.CQColors.themeColor1} !important;
		opacity: 1;
		display: flex;
		align-items: center;
	}

	&& .ant-select-arrow, 
	&& .ant-select-suffix {
		color: ${({ theme }) => theme.CQColors.themeColor1} !important;
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
		font-size: 15px !important;
		margin-top: 0 !important;
	}

	// Hover, focus, open: invert colors
	&&:hover .ant-select-selector,
	&&.ant-select-focused .ant-select-selector,
	&&.ant-select-open .ant-select-selector {
		background: linear-gradient(270deg, #169191 0%, #82c446 100%) !important;
		color: #fff !important;
		border: 1.5px solid transparent !important;
	}

	&&:hover .ant-select-selection-placeholder,
	&&.ant-select-focused .ant-select-selection-placeholder,
	&&.ant-select-open .ant-select-selection-placeholder {
		color: #fff !important;
	}

	&&:hover .ant-select-arrow,
	&&.ant-select-focused .ant-select-arrow,
	&&.ant-select-open .ant-select-arrow,
	&&:hover .ant-select-suffix,
	&&.ant-select-focused .ant-select-suffix,
	&&.ant-select-open .ant-select-suffix {
		color: #fff !important;
	}

	// Disabled state
	&&.ant-select-disabled .ant-select-selector {
		background: #f5f5f5 !important;
		color: #bfbfbf !important;
		border: 1.5px solid #d9d9d9 !important;
		opacity: 0.7;
	}
	&&.ant-select-disabled .ant-select-arrow,
	&&.ant-select-disabled .ant-select-suffix {
		color: #bfbfbf !important;
	}
	
	// Remove border on focus
	&& .ant-select-focused .ant-select-selector {
		box-shadow: none !important;
	}

	min-width: 120px;
	max-width: 220px;
`;
export const XThemeReclaim2Button = styled(Button)`
	background: #0e4c88;
	border-radius: 16px;
	font-weight: 600;
	font-size: 14px;
	line-height: 30px;
	color: ${({ theme }) => theme.CQColors.white};
	transition: all 0.35s;
	min-height: 36px;
	&:hover {
		color: ${({ theme }) => theme.CQColors.themeColor1} !important;
		transition: all 0.35s;
		background: #0e4c88 !important;
		border: 1px solid transparent !important;
		img {
			filter: brightness(0) saturate(100%) invert(13%) sepia(85%) saturate(3688%) hue-rotate(199deg) brightness(93%) contrast(89%);
		}
	}
	&.noBackground,
	&.backgroundRevers {
		position: relative;
		min-height: 36px;
		border-radius: 16px;
		color:  #0e4c88; !important;
		transition: all 0.35s;
		background: linear-gradient(#fff, #fff) padding-box,
			linear-gradient(60deg, #0e4c88, #0e4c88) border-box !important;
		border: 1px solid transparent !important;
		img {
			/* filter: brightness(0) saturate(100%) invert(8%) sepia(4%)
				saturate(7%) hue-rotate(335deg) brightness(100%) contrast(89%) !important; */
			filter: brightness(0) saturate(100%) invert(46%) sepia(59%)
				saturate(599%) hue-rotate(131deg) brightness(89%) contrast(87%);
		}
		&:hover {
			border: 1px solid transparent !important;
			background: #0e4c88 !important;
			color: ${({ theme }) => theme.CQColors.white} !important;
			&::before {
				display: none;
			}
			.ant-btn-icon img {
				filter: brightness(0) saturate(100%) invert(100%) sepia(5%)
					saturate(3%) hue-rotate(18deg) brightness(103%)
					contrast(100%) !important;
			}
		}
	}
	&.borderColor {
		border: 1px solid ${({ theme }) => theme.CQColors.borderColor} !important;
	}
	&.chatStyle {
		width: 30px !important;
		height: 30px !important;
		min-height: 30px !important;
		border-radius: 5px !important;
		line-height: 30px !important;
		border-color: transparent !important;
		svg {
			font-size: 14px !important;
		}
	}
`;

export const XThemeReclaimSuggestionBTN = styled(Button)`
	background: ${({ theme }) => theme.CQColors.bodyBg};
	color: ${({ theme }) => theme.CQColors.themeColor6};
	border-color: ${({ theme }) => theme.CQColors.themeColor4};
	border-radius: 10px;
	font-weight: 400;
	font-size: 10px;
	line-height: 18px;
	svg {
		opacity: 0.2;
		font-size: 16px !important;
	}
	&:hover {
		background: #0e4c88 !important;
		color: ${({ theme }) => theme.CQColors.white} !important;
		border-color: ${({ theme }) => theme.CQColors.white} !important;
		svg,
		img {
			opacity: 1 !important;
			filter: brightness(0) saturate(100%) invert(100%) sepia(0%)
				saturate(7493%) hue-rotate(237deg) brightness(107%)
				contrast(102%) !important;
		}
	}
`;

export const XThemeReclaimActionBtn = styled(Button)`
	// background: rgba(0, 114, 153, 0.05);
	background: linear-gradient(#fff, #fff) padding-box,
		linear-gradient(60deg, #0e4c88, #0e4c88) border-box !important;
	color: #0e4c88 !important;
	border: 1px solid rgba(0, 107, 185, 0.1);
	border-radius: 6px;
	margin-bottom: 5px;
	font-weight: 500;
	font-size: 12px !important;
	// color: ${({ theme }) => theme.colors.themeColor8};
	img {
		margin-bottom: 10px;
		filter: brightness(0) saturate(100%) invert(19%) sepia(99%)
			saturate(2489%) hue-rotate(178deg) brightness(101%) contrast(101%);
	}
	&:hover {
		background: #0e4c88 !important;
		color: ${({ theme }) => theme.colors.white} !important;
		border-color: ${({ theme }) => theme.colors.white} !important;
		img {
			filter: brightness(0) saturate(100%) invert(94%) sepia(25%)
				saturate(2%) hue-rotate(12deg) brightness(110%) contrast(100%);
		}
	}
	&.chip-item {
		background: #fff;
		border: 1px solid #e8e8e8;
		transition: all 0.3s ease;

		&:hover {
			background: #0e4c88 !important;
			color: #fff;
			border-color: #0e4c88;
		}
	}
`;
